<template>
  <!-- lnb -->
  <div class="krx-lnb">
    
  </div>
</template>

<script>
import Util from "@/util";
import CitizenParticipationDialog from "@/components/popup/CitizenParticipationDialog";
export default {
  components: {
    CitizenParticipationDialog,
  },
  data: () => ({
    citizenParticipationDialog: {
      dialog: false,
    },
    isActive: false,
    pageList: [
      // {
      //   class: "m01",
      //   link: "/hero",
      //   title: "전체회의",
      //   imagePath: "/static/images/button/all.svg",
      //   isActive: false,
      // },
      {
        class: "m02",
        link: "/myMeeting",
        title: "영상회의",
        imagePath: "/static/images/button/krxVideo.svg",
        isActive: false,
      },
      {
        link: "/myMeeting2",
        title: "부가기능",
        imagePath: "/static/images/button/etcFunc.svg",
        isActive: false,
        child: [
          {
            href: "/manageUser",
            title: "회의실 신청",
            imagePath: "/static/images/button/addRoom.png",
          },
        ],
      },
      // {
      //   class: "m03",
      //   link: "/joinMeeting",
      //   title: "일반회의",
      //   imagePath: "/static/images/button/krxGeneral.svg",
      //   isActive: false,
      // },
      // {
      //   class: "m04",
      //   link: "/manageVideoMeetingRoom",
      //   imagePath: "/static/images/button/etcFunc.svg",
      //   title: "부가기능",
      //   isActive: false,
      // },
    ],
  }),
  created() {
    if (!Util.hasSession(this, true)) return;
  },
  methods: {
    currentPage: function(obj) {
      this.pageList.forEach(element => {
        element.isActive = false;
      });
      this.$router.push(obj.link);
      obj.isActive = true;
    },
    goUserPage() {
      this.$router.push(`/myMeeting`);
    },
    openJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = true;
    },
    closeJoinMeetingDialog() {
      this.citizenParticipationDialog.dialog = false;
    },
  },
};
</script>

<style scoped>
.side-list {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-items: center;
  margin-left: 24px;
  height: 47px;
  width: 173px;
  cursor: pointer;
  padding: 12px 16px;
}

.side-list:hover {
  border-radius: 4px;
  background: rgba(100, 73, 252, 0.06);
}
.txt {
  font-weight: 500;
  margin-left: 8px;
  font-size: 16px;
}

.child-row span {
  font-weight: 500;
  font-size: 16px;
  margin-left: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/krx/KrxLnb.vue